import axios from 'axios'
import {
  PersonModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
  TableResumen,
  DocumentModel,
  ClotheModel,
  UpdateClotheForm,
  ResponseCrudId,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getPerson(dto: PersonModel, page: number) {
  return axios.post<ResponseObjectPaginated<PersonModel[]>>(`${BASEURL}/person/getAll/${page}`, dto)
}

export function getPersonById(dto: any) {
  return axios.get<ResponseObject<PersonModel>>(
    `${BASEURL}/person/getInformationById?PersonId=${encodeURIComponent(dto)}`,
  )
}

export function createPerson(dto: PersonModel) {
  return axios.post<ResponseCrudId>(`${BASEURL}/person/createPerson`, dto)
}

export function deletePerson(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/person/deletePerson?id=${dto}`)
}

export function updatePerson(dto: PersonModel) {
  return axios.put<ResponseCrudId>(`${BASEURL}/person/updatePerson`, dto)
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplatePerson() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/person/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasivePerson(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/person/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE

// INICIO ---- DOCUMENT BY PERSON

export function getDocumentByPerson(page: number, id: any, empresaId: string = '') {
  return axios.post<ResponseObjectPaginated<DocumentModel[]>>(
    `${BASEURL}/person/getAllDocument?personaId=${id}&pageNumber=${page}&empresaId=${empresaId}`,
  )
}

export function createDocumentByPerson(dto: DocumentModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/person/createPersonDocument`, dto)
}

export function deleteDocumentByPerson(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/person/deletePersonDocument?id=${dto}`)
}

export function updateDocumentByPerson(dto: DocumentModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/person/updatePersonDocument`, dto)
}

export function updateDefaultDocumentByPerson(id: any) {
  return axios.get<ResponseCRUD>(
    `${BASEURL}/person/updatePersonDocumentDefault?documentoPersonaId=${id}`,
  )
}
// FIN ---- DOCUMENT BY PERSON
// INICIO ---- CLOTHE BY PERSON

export function getClothesByPerson(page: number, size: number, id: any) {
  return axios.post<ResponseObjectPaginated<ClotheModel[]>>(
    `${BASEURL}/person/getAllClothes/${page}?personaId=${id}&size=${size}`,
  )
}

export function createClotheByPerson(dto: UpdateClotheForm) {
  return axios.post<ResponseCRUD>(`${BASEURL}/person/createPersonClothes`, dto)
}

export function updateClotheByPerson(dto: UpdateClotheForm) {
  return axios.put<ResponseCRUD>(`${BASEURL}/person/updatePersonClothes`, dto)
}

export function getInformationClothesById(id: any) {
  return axios.get<ResponseObject<ClotheModel>>(
    `${BASEURL}/person/getInformationClothesById?id=${encodeURIComponent(id)}`,
  )
}
